import {
	Box,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { useState } from "react";
import CommCard from "src/common/CommCard";
import { CommonPagination } from "src/common/CommonPagination";
import ModalsWrapper from "src/components/Modals/ModalsWrapper";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { IVisitorMoneyReceipt } from "../type/visitorType";
import CreateVisitorMoneyReceipt from "./CreateVisitorMoneyReceipt";
import VisitorMoneyReceiptTableRow from "./VisitorMoneyReceiptTableRow";

const MoneyReceiptList = () => {
	const [pagination, setPagination] = useState({
		limit: 50,
		skip: 0,
	});
	const [search, setSearch] = useState("");
	const [dateRange, setDateRange] = useState(undefined);
	const { data: MoneyReceiptList, isLoading } = useGetQueryWithTotal<
		IVisitorMoneyReceipt[]
	>({
		endPoint: "/api/admin/visitor/money-receipt",
		queryKeys: ["visitor-money-receipt"],
		params: { pagination, money_receipt_no: search, dateRange },
	});
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<CommCard
			helmetTitle={"BTTF - Money Receipt List"}
			headerTitle={`Money Receipt List (${MoneyReceiptList?.total})`}
			showButton
			showCardHeader
			handleBtnForModalFun={handleOpen}
			btnText='Create Money Receipt'
			showSearch
			handleSearchFun={(value) => setSearch(value)}
			showDateRange
			handleDateRange={(value) => setDateRange(value)}
		>
			<>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>SL.</TableCell>
								<TableCell>Date</TableCell>
								<TableCell>Receipt No.</TableCell>
								<TableCell>Account Type</TableCell>
								<TableCell>Total Amount</TableCell>
								<TableCell>Action</TableCell>
							</TableRow>
						</TableHead>

						{isLoading ? (
							<TableLoader />
						) : MoneyReceiptList?.data?.length > 0 ? (
							<TableBody>
								{MoneyReceiptList?.data?.map(
									(
										moneyRece: IVisitorMoneyReceipt,
										index
									) => {
										return (
											<VisitorMoneyReceiptTableRow
												key={moneyRece.id}
												moneyReceipt={moneyRece}
												serial={index + 1}
												paginationSkip={pagination.skip}
											/>
										);
									}
								)}
							</TableBody>
						) : (
							<TableNotFound />
						)}
					</Table>
				</TableContainer>

				<Box p={2}>
					<CommonPagination
						total={MoneyReceiptList?.total}
						paginationCalFun={(limit: number, skip: number) => {
							setPagination({ limit, skip });
						}}
					/>
				</Box>

				<ModalsWrapper
					showModal={open}
					setShowModal={setOpen}
					modalData={{ title: "Create Money Receipt" }}
				>
					<CreateVisitorMoneyReceipt handleClose={handleClose} />
				</ModalsWrapper>
			</>
		</CommCard>
	);
};

export default MoneyReceiptList;
